export default "__VITE_ASSET__BRXqyju6__"